// extracted by mini-css-extract-plugin
export default {"videoThumbnail":"FS3fbZbKK3"};